export default {
    WHITE:"#FFFFFF"
}